import React from 'react';

export default () => (
  <div className="App">
    <div>
      <div>
        <div>Welcome to home.</div>
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/routes/Home.js